import { Checkbox, DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import React, { PureComponent } from 'react';
import { API_DATE_FS } from './shared';


export class UsiFormItems extends PureComponent {
  static slug = 'usi';

  constructor(props) {
    super(props);
    this.state = { };
  }

  static getSubmissionData(checkData, constituent) {
    return {
      identifier: checkData.document_number,
      issued_by: checkData.issued_by,
      course_level: checkData.course_level,
      course_completed: !!checkData.course_completed,
      course_code: checkData.course_code,
      attainment: checkData.attainment.format(API_DATE_FS),
      ...checkData.expiry && { expiry: checkData.expiry.format(API_DATE_FS)},
      fullName: constituent.get('fullName'),
    };
  }

  disablePastDate = current => {
    // Can not select days before today and today
    return current && current < moment().endOf('day');
  }

  disableAttainmentDate = current => {
    // Can not select days after today
    return current && current > moment().endOf('day');
  }

  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;
    const { slug } = this.constructor;

    const ident = {
      label: 'Certificate Number',
      slug: `${slug}.document_number`,
    };
    const issuedBy = {
      label: 'Issued By',
      slug: `${slug}.issued_by`,
    };
    const courseLevel = {
      label: 'Course Level',
      slug: `${slug}.course_level`,
    };
    const courseCompleted = {
      label: 'Course Completed',
      slug: `${slug}.course_completed`,
    };
    const courseCode = {
      label: 'Course Code',
      slug: `${slug}.course_code`,
    };
    const dateAttained = {
      label: 'Date Attained',
      slug: `${slug}.attainment`,
    };
    const expiry = {
      label: 'Expiration Date',
      slug: `${slug}.expiry`,
    };

    return (<>
      <Form.Item label={ courseLevel.label }>
        { getFieldDecorator(courseLevel.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${courseLevel.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Select
            showSearch
            disabled={ disabled }
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
          >
            <Select.Option key="certificate-opt" value="Certificate">Certificate</Select.Option>
            <Select.Option key="diploma-opt" value="Diploma">Diploma</Select.Option>
            <Select.Option key="degree-opt" value="Degree">Degree</Select.Option>
            <Select.Option key="other-opt" value="Other">Other</Select.Option>
          </Select>,
        )
        }
      </Form.Item>
      <Form.Item label={ issuedBy.label }>
        { getFieldDecorator(issuedBy.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${issuedBy.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Input
            disabled={ disabled }
          />,
        )
        }
      </Form.Item>
      <Form.Item label={ ident.label }>
        { getFieldDecorator(ident.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${ident.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Input
            disabled={ disabled }
          />,
        )
        }
      </Form.Item>
      <Form.Item label={ courseCompleted.label }>
        { getFieldDecorator(courseCompleted.slug, {
          rules: [...(rules || [])],
        })(
          <Checkbox
            disabled={ disabled }
          />,
        )
        }
      </Form.Item>
      <Form.Item label={ courseCode.label }>
        { getFieldDecorator(courseCode.slug, {
          rules: [
            {
              required: true,
              whitespace: true,
              message: `${courseCode.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <Input
            disabled={ disabled }
          />,
        )
        }
      </Form.Item>
      <Form.Item label={ dateAttained.label }>
        {getFieldDecorator(dateAttained.slug, {
          rules: [
            {
              required: true,
              message: `${dateAttained.label} is required`,
            },
            ...(rules || []),
          ],
        })(
          <DatePicker
            format="DD-MM-YYYY"
            placeholder="DD-MM-YYYY"
            disabled={disabled}
            disabledDate={this.disableAttainmentDate}
          />,
        )}
      </Form.Item>
      <Form.Item label={ expiry.label }>
      {getFieldDecorator(expiry.slug, {
          rules: [...(rules || [])],
        })(
          <DatePicker
            format="DD-MM-YYYY"
            placeholder="DD-MM-YYYY"
            disabled={disabled}
            disabledDate={this.disablePastDate}
          />,
        )}
      </Form.Item>
    </>);
  }
}
